/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType, type RequestExtraParams, request } from '@/utils/request'
import type {
  SeaWhaleApiAliLoginPostData,
  SeaWhaleApiAliLoginPostPayload,
  SeaWhaleApiThirdPartyUserLoginThirdpartyPostData,
  SeaWhaleApiThirdPartyUserLoginThirdpartyPostPayload,
  SeaWhaleApiThirdPartyUserSendBoundEmailCodePostData,
  SeaWhaleApiThirdPartyUserSendBoundEmailCodePostPayload,
  SeaWhaleApiThirdPartyUserSignupThirdpartyPostData,
  SeaWhaleApiThirdPartyUserSignupThirdpartyPostPayload,
  SeaWhaleApiThirdPartyUserWeChatRedirectInfoPostData,
  SeaWhaleApiThirdPartyUserWeChatRedirectInfoPostPayload,
  SeaWhaleApiUserChangeEmailPostData,
  SeaWhaleApiUserChangeEmailPostPayload,
  SeaWhaleApiUserChangeMobilePostData,
  SeaWhaleApiUserChangeMobilePostPayload,
  SeaWhaleApiUserDeleteAccountPostData,
  SeaWhaleApiUserDeleteAccountPostPayload,
  SeaWhaleApiUserExtenDurationPostData,
  SeaWhaleApiUserExtenDurationPostPayload,
  SeaWhaleApiUserLoginPostData,
  SeaWhaleApiUserLoginPostPayload,
  SeaWhaleApiUserLoginRegisterWaySwitchPostData,
  SeaWhaleApiUserLoginRegisterWaySwitchPostPayload,
  SeaWhaleApiUserQueryPostData,
  SeaWhaleApiUserQueryPostPayload,
  SeaWhaleApiUserQuickLoginPostData,
  SeaWhaleApiUserQuickLoginPostPayload,
  SeaWhaleApiUserQuickLoginQueryPostData,
  SeaWhaleApiUserQuickLoginQueryPostPayload,
  SeaWhaleApiUserSendChangeMobileCodePostData,
  SeaWhaleApiUserSendChangeMobileCodePostPayload,
  SeaWhaleApiUserSendDeleteAccountCodePostData,
  SeaWhaleApiUserSendDeleteAccountCodePostPayload,
  SeaWhaleApiUserSendDeleteAccountEmailCodePostData,
  SeaWhaleApiUserSendDeleteAccountEmailCodePostPayload,
  SeaWhaleApiUserSendSignupCodePostData,
  SeaWhaleApiUserSendSignupCodePostPayload,
  SeaWhaleApiUserSendUpdateContactPhoneCodePostData,
  SeaWhaleApiUserSendUpdateContactPhoneCodePostPayload,
  SeaWhaleApiUserSignoutPostData,
  SeaWhaleApiUserSignoutPostPayload,
  SeaWhaleApiUserSignupPostData,
  SeaWhaleApiUserSignupPostPayload,
  SeaWhaleApiUserUpdateContactPhonePostData,
  SeaWhaleApiUserUpdateContactPhonePostPayload,
  SeaWhaleApiUserUpdatePostData,
  SeaWhaleApiUserUpdatePostPayload,
} from './data-contracts'

export type { ParamData, ReturnPromise } from '@/utils/request'

const baseUrl: string = '/sea_shell'

/**
 * No description
 *
 * @tags MemberApi
 * @name SeaWhaleApiAliLoginPost
 * @summary AlipayCn-一键登录
 * @request POST:/sea_whale_api/ali/login
 */
export function seaWhaleApiAliLoginPost(root: SeaWhaleApiAliLoginPostPayload, params: RequestExtraParams = {}) {
  return request<SeaWhaleApiAliLoginPostData, any>({
    url: baseUrl + `/sea_whale_api/ali/login`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * No description
 *
 * @tags MemberApi
 * @name SeaWhaleApiThirdPartyUserWeChatRedirectInfoPost
 * @summary 网页微信登录重定向信息
 * @request POST:/sea_whale_api/thirdPartyUser/weChatRedirectInfo
 */
export function seaWhaleApiThirdPartyUserWeChatRedirectInfoPost(
  root: SeaWhaleApiThirdPartyUserWeChatRedirectInfoPostPayload,
  params: RequestExtraParams = {},
) {
  return request<SeaWhaleApiThirdPartyUserWeChatRedirectInfoPostData, any>({
    url: baseUrl + `/sea_whale_api/thirdPartyUser/weChatRedirectInfo`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * No description
 *
 * @tags MemberApi
 * @name SeaWhaleApiThirdPartyUserSendBoundEmailCodePost
 * @summary 三方登录-发送绑定邮箱验证码
 * @request POST:/sea_whale_api/thirdPartyUser/sendBoundEmailCode
 */
export function seaWhaleApiThirdPartyUserSendBoundEmailCodePost(
  root: SeaWhaleApiThirdPartyUserSendBoundEmailCodePostPayload,
  params: RequestExtraParams = {},
) {
  return request<SeaWhaleApiThirdPartyUserSendBoundEmailCodePostData, any>({
    url: baseUrl + `/sea_whale_api/thirdPartyUser/sendBoundEmailCode`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * No description
 *
 * @tags MemberApi
 * @name SeaWhaleApiThirdPartyUserSignupThirdpartyPost
 * @summary 三方登录-注册
 * @request POST:/sea_whale_api/thirdPartyUser/signupThirdparty
 */
export function seaWhaleApiThirdPartyUserSignupThirdpartyPost(
  root: SeaWhaleApiThirdPartyUserSignupThirdpartyPostPayload,
  params: RequestExtraParams = {},
) {
  return request<SeaWhaleApiThirdPartyUserSignupThirdpartyPostData, any>({
    url: baseUrl + `/sea_whale_api/thirdPartyUser/signupThirdparty`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * No description
 *
 * @tags MemberApi
 * @name SeaWhaleApiThirdPartyUserLoginThirdpartyPost
 * @summary 三方登录-登录
 * @request POST:/sea_whale_api/thirdPartyUser/loginThirdparty
 */
export function seaWhaleApiThirdPartyUserLoginThirdpartyPost(
  root: SeaWhaleApiThirdPartyUserLoginThirdpartyPostPayload,
  params: RequestExtraParams = {},
) {
  return request<SeaWhaleApiThirdPartyUserLoginThirdpartyPostData, any>({
    url: baseUrl + `/sea_whale_api/thirdPartyUser/loginThirdparty`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * No description
 *
 * @tags MemberApi
 * @name SeaWhaleApiUserQuickLoginQueryPost
 * @summary 一键登录前查询（获取验证码）
 * @request POST:/sea_whale_api/user/quickLoginQuery
 */
export function seaWhaleApiUserQuickLoginQueryPost(
  root: SeaWhaleApiUserQuickLoginQueryPostPayload,
  params: RequestExtraParams = {},
) {
  return request<SeaWhaleApiUserQuickLoginQueryPostData, any>({
    url: baseUrl + `/sea_whale_api/user/quickLoginQuery`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * No description
 *
 * @tags MemberApi
 * @name SeaWhaleApiUserQuickLoginPost
 * @summary 一键登录
 * @request POST:/sea_whale_api/user/quickLogin
 */
export function seaWhaleApiUserQuickLoginPost(
  root: SeaWhaleApiUserQuickLoginPostPayload,
  params: RequestExtraParams = {},
) {
  return request<SeaWhaleApiUserQuickLoginPostData, any>({
    url: baseUrl + `/sea_whale_api/user/quickLogin`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * No description
 *
 * @tags MemberApi
 * @name SeaWhaleApiUserSendSignupCodePost
 * @summary 发送 注册 验证码（邮箱、手机号通用）
 * @request POST:/sea_whale_api/user/sendSignupCode
 */
export function seaWhaleApiUserSendSignupCodePost(
  root: SeaWhaleApiUserSendSignupCodePostPayload,
  params: RequestExtraParams = {},
) {
  return request<SeaWhaleApiUserSendSignupCodePostData, any>({
    url: baseUrl + `/sea_whale_api/user/sendSignupCode`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * No description
 *
 * @tags MemberApi
 * @name SeaWhaleApiUserSignupPost
 * @summary 注册
 * @request POST:/sea_whale_api/user/signup
 */
export function seaWhaleApiUserSignupPost(root: SeaWhaleApiUserSignupPostPayload, params: RequestExtraParams = {}) {
  return request<SeaWhaleApiUserSignupPostData, any>({
    url: baseUrl + `/sea_whale_api/user/signup`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * No description
 *
 * @tags MemberApi
 * @name SeaWhaleApiUserLoginPost
 * @summary 登录
 * @request POST:/sea_whale_api/user/login
 */
export function seaWhaleApiUserLoginPost(root: SeaWhaleApiUserLoginPostPayload, params: RequestExtraParams = {}) {
  return request<SeaWhaleApiUserLoginPostData, any>({
    url: baseUrl + `/sea_whale_api/user/login`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * No description
 *
 * @tags MemberApi
 * @name SeaWhaleApiUserExtenDurationPost
 * @summary 延长会员Token有效期
 * @request POST:/sea_whale_api/user/extenDuration
 */
export function seaWhaleApiUserExtenDurationPost(
  root: SeaWhaleApiUserExtenDurationPostPayload,
  params: RequestExtraParams = {},
) {
  return request<SeaWhaleApiUserExtenDurationPostData, any>({
    url: baseUrl + `/sea_whale_api/user/extenDuration`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * No description
 *
 * @tags MemberApi
 * @name SeaWhaleApiUserQueryPost
 * @summary 会员查询
 * @request POST:/sea_whale_api/user/query
 */
export function seaWhaleApiUserQueryPost(root: SeaWhaleApiUserQueryPostPayload, params: RequestExtraParams = {}) {
  return request<SeaWhaleApiUserQueryPostData, any>({
    url: baseUrl + `/sea_whale_api/user/query`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * No description
 *
 * @tags MemberApi
 * @name SeaWhaleApiUserUpdatePost
 * @summary 会员更新
 * @request POST:/sea_whale_api/user/update
 */
export function seaWhaleApiUserUpdatePost(root: SeaWhaleApiUserUpdatePostPayload, params: RequestExtraParams = {}) {
  return request<SeaWhaleApiUserUpdatePostData, any>({
    url: baseUrl + `/sea_whale_api/user/update`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * No description
 *
 * @tags MemberApi
 * @name SeaWhaleApiUserSignoutPost
 * @summary 登出
 * @request POST:/sea_whale_api/user/signout
 */
export function seaWhaleApiUserSignoutPost(root: SeaWhaleApiUserSignoutPostPayload, params: RequestExtraParams = {}) {
  return request<SeaWhaleApiUserSignoutPostData, any>({
    url: baseUrl + `/sea_whale_api/user/signout`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * No description
 *
 * @tags MemberApi
 * @name SeaWhaleApiUserSendDeleteAccountEmailCodePost
 * @summary 发送删除账户邮箱验证码
 * @request POST:/sea_whale_api/user/sendDeleteAccountEmailCode
 */
export function seaWhaleApiUserSendDeleteAccountEmailCodePost(
  root: SeaWhaleApiUserSendDeleteAccountEmailCodePostPayload,
  params: RequestExtraParams = {},
) {
  return request<SeaWhaleApiUserSendDeleteAccountEmailCodePostData, any>({
    url: baseUrl + `/sea_whale_api/user/sendDeleteAccountEmailCode`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * No description
 *
 * @tags MemberApi
 * @name SeaWhaleApiUserSendDeleteAccountCodePost
 * @summary 发送删除账户验证码（邮箱、手机号通用版）
 * @request POST:/sea_whale_api/user/sendDeleteAccountCode
 */
export function seaWhaleApiUserSendDeleteAccountCodePost(
  root: SeaWhaleApiUserSendDeleteAccountCodePostPayload,
  params: RequestExtraParams = {},
) {
  return request<SeaWhaleApiUserSendDeleteAccountCodePostData, any>({
    url: baseUrl + `/sea_whale_api/user/sendDeleteAccountCode`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * No description
 *
 * @tags MemberApi
 * @name SeaWhaleApiUserDeleteAccountPost
 * @summary 删除账户
 * @request POST:/sea_whale_api/user/deleteAccount
 */
export function seaWhaleApiUserDeleteAccountPost(
  root: SeaWhaleApiUserDeleteAccountPostPayload,
  params: RequestExtraParams = {},
) {
  return request<SeaWhaleApiUserDeleteAccountPostData, any>({
    url: baseUrl + `/sea_whale_api/user/deleteAccount`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * No description
 *
 * @tags MemberApi
 * @name SeaWhaleApiUserSendUpdateContactPhoneCodePost
 * @summary 发送更新联系电话验证码
 * @request POST:/sea_whale_api/user/sendUpdateContactPhoneCode
 */
export function seaWhaleApiUserSendUpdateContactPhoneCodePost(
  root: SeaWhaleApiUserSendUpdateContactPhoneCodePostPayload,
  params: RequestExtraParams = {},
) {
  return request<SeaWhaleApiUserSendUpdateContactPhoneCodePostData, any>({
    url: baseUrl + `/sea_whale_api/user/sendUpdateContactPhoneCode`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * No description
 *
 * @tags MemberApi
 * @name SeaWhaleApiUserUpdateContactPhonePost
 * @summary 更新联系电话
 * @request POST:/sea_whale_api/user/updateContactPhone
 */
export function seaWhaleApiUserUpdateContactPhonePost(
  root: SeaWhaleApiUserUpdateContactPhonePostPayload,
  params: RequestExtraParams = {},
) {
  return request<SeaWhaleApiUserUpdateContactPhonePostData, any>({
    url: baseUrl + `/sea_whale_api/user/updateContactPhone`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * No description
 *
 * @tags MemberApi
 * @name SeaWhaleApiUserSendChangeMobileCodePost
 * @summary 发送换绑手机号验证码
 * @request POST:/sea_whale_api/user/sendChangeMobileCode
 */
export function seaWhaleApiUserSendChangeMobileCodePost(
  root: SeaWhaleApiUserSendChangeMobileCodePostPayload,
  params: RequestExtraParams = {},
) {
  return request<SeaWhaleApiUserSendChangeMobileCodePostData, any>({
    url: baseUrl + `/sea_whale_api/user/sendChangeMobileCode`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * No description
 *
 * @tags MemberApi
 * @name SeaWhaleApiUserChangeMobilePost
 * @summary 换绑手机号
 * @request POST:/sea_whale_api/user/changeMobile
 */
export function seaWhaleApiUserChangeMobilePost(
  root: SeaWhaleApiUserChangeMobilePostPayload,
  params: RequestExtraParams = {},
) {
  return request<SeaWhaleApiUserChangeMobilePostData, any>({
    url: baseUrl + `/sea_whale_api/user/changeMobile`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * No description
 *
 * @tags MemberApi
 * @name SeaWhaleApiUserChangeEmailPost
 * @summary 换绑邮箱
 * @request POST:/sea_whale_api/user/changeEmail
 */
export function seaWhaleApiUserChangeEmailPost(
  root: SeaWhaleApiUserChangeEmailPostPayload,
  params: RequestExtraParams = {},
) {
  return request<SeaWhaleApiUserChangeEmailPostData, any>({
    url: baseUrl + `/sea_whale_api/user/changeEmail`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * No description
 *
 * @tags MemberApi
 * @name SeaWhaleApiUserLoginRegisterWaySwitchPost
 * @summary 登录、注册方式开关
 * @request POST:/sea_whale_api/user/loginRegisterWaySwitch
 */
export function seaWhaleApiUserLoginRegisterWaySwitchPost(
  root: SeaWhaleApiUserLoginRegisterWaySwitchPostPayload,
  params: RequestExtraParams = {},
) {
  return request<SeaWhaleApiUserLoginRegisterWaySwitchPostData, any>({
    url: baseUrl + `/sea_whale_api/user/loginRegisterWaySwitch`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}
